import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';

import { AuthService } from '@auth0/auth0-angular';
import { TokenService } from '../services/token.service';
import { AppConfigService } from '../services/app-config.service';
import { catchError, throwError, Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private readonly auth: AuthService,
    private readonly tokenService: TokenService,
    private readonly appConfigService: AppConfigService,
    private readonly router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const token = this.tokenService.getToken();
    
    if (token && this.tokenService.isTokenExpired(token)) {
      this.handleTokenExpired();
      return throwError(() => new Error('Token expired'));
    } 

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isAuthenticationError(error)) {
          this.handleAuthenticationError();
        }
        return throwError(() => error);
      })
    );
  }

  private handleTokenExpired(): void {
    this.tokenService.clearToken();
    this.performEnvironmentAwareLogout();
  }

  private handleAuthenticationError(): void {
    this.tokenService.clearToken();
    this.performEnvironmentAwareLogout();
  }

  private isAuthenticationError(error: HttpErrorResponse): boolean {
    return error && (error.status === 401 || error.status === 403);
  }

  private performEnvironmentAwareLogout(): void {
    const config = this.appConfigService.getConfig();
    const appUri = config?.appUri;

    if (appUri) {
      this.auth.logout({
        logoutParams: {
          returnTo: appUri
        }
      });
    } else {
      console.warn('No appUri configured, using default logout behavior');
      this.auth.logout();
    }
  }
}